@if (this.service.isLoaded && this.service.isActive && !this.service.isReloading) {
  <div class="maintenance-mode">
    <div class="container animated">
      <h1>{{translateService.instant("main.maintenance.title")}}</h1>
      <p>{{translateService.instant("main.maintenance.description")}}</p>
      <time class="bold">{{this.service.nextEndTime | date:'MMM d y, h:mm a'}}</time>
      <a class="sign-out" routerLink="/signout">{{translateService.instant("main.labels.Sign_out") }}</a>
    </div>
  </div>
}
<!--
<ng-container *ngIf="!this.service.isContentVisible">
  -->
  <div [hidden]="!this.service.isContentVisible">
    <ng-content ></ng-content>
  </div>
<!--</ng-container>-->

